import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";
import ReactTooltip from 'react-tooltip';

//import filter modal
import FilterModal from "../../components/Modal/FilterModal";

import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequestForm,
  putRequest,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
import BuyProduct from "components/Modal/BuyProduct";

const filterObj = {
  first_name: "",
  last_name: "",
  gender: "",
  email: "",
  phone: "",
  country: "",
  nationality: "",
  bookingCode: "",
  bookingDate: "",
  agentEmail: "",
};

const ProductManagementlist = (props) => {
  console.log("props", props);
  const [buyProductdata, setBuyProductdata] = useState({});
  const [modal_center, setmodal_center] = useState(false);
  const [Productdata, setProductdata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  // const [value, setValue] = React.useState(10);
  const [sort, setsort] = React.useState("");
  const [sortOrder, setsortOrder] = React.useState("desc");
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [CMshow, setCMshow] = useState(false);
  const [kuliesCommValue, setKuliesCommValue] = useState(0);
  const [kuliesComm, setKuliesComm] = useState({});
  const [comValidation, setComValidation] = useState('');
  
  const [filter, setFilter] = useState({ ...filterObj });

  useEffect(() => {
    ProductManagment();
  }, [currentPage]);

  useEffect(() => {
    setKuliesCommValue(kuliesComm?.adminCommission || 0);
  }, [kuliesComm]);

  useEffect(() => {
    ProductManagment();
  }, [sort, sortOrder]);

  const GetValueOnChange = async (value, productId) => {
    let isPublished = value === true ? false : true;
    const res = await postRequest("product/update-by-admin", { productId, isPublished });
    if (res.status) {
      toast.success("Product Status updated Successfully");
      ProductManagment();
    } else {
      toast.error("Something went wrong");
      setLoader(false);
    }
  };
  const closeModal = () => {
    setModel(!model);
  };

  const toggleModel = (data) => {
    setBuyProductdata(data);
    setModel(!model);
  };
  const CMtoggleModel = (item) => {
    setCMshow(true);
    setKuliesComm(item)
  };

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  

  const updateFilter = (key, value) => {
    const filterObj = { ...filter };
    filterObj[key] = value;
    setFilter(filterObj);
  };

  const applyFilter = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {
        var filterObject = {
          [key]: filter[key],
        };

        if (key === "title") {
          filterObject.type = "regex";
        } else if (key === "homeBlockType") {
          filterObject.type = "eq";
        } else if (key === "sizeId") {
          filterObject.type = "obj-eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });

    console.log("filterArgs", filterArgs);
    toggleModel();
    ProductManagment(filterArgs);
  };

  const getFilters = () => {
    const filterArgs = [];

    Object.keys(filter).forEach((key) => {
      if (
        filter[key] !== "" &&
        filter[key] !== null &&
        filter[key] !== undefined
      ) {
        var filterObject = {
          [key]: filter[key],
        };

        if (key === "title") {
          filterObject.type = "regex";
        } else if (key === "homeBlockType") {
          filterObject.type = "eq";
        } else if (key === "sizeId") {
          filterObject.type = "obj-eq";
        } else if (key === "createdAt") {
          filterObject.type = "date-eq";
        }

        filterArgs.push(filterObject);
      }
    });
    return filterArgs;
  };

  const resetFilter = () => {
    setFilter({ ...filterObj });
    toggleModel();
    ProductManagment();
  };

  function createdAtdata(cellContent, row) {
    return (
      <React.Fragment>
        <div>
          <p>{moment(row.createdAt).format("DD-MM-YYYY")} </p>
        </div>
      </React.Fragment>
    );
  }

  function activeFormatter(cellContent, row) {
    const isActive = row?.isPublished;
    console.log(isActive);
    return (
      <button
        className={`btn ${isActive !== false ? "btn-active" : "btn-deactive"}`}
        type="button"
        onClick={() => GetValueOnChange(isActive, row._id)}
      >
        {isActive !== false ? "Active" : "InActive"}
      </button>
    );
  }

  function ProductFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row.images[0]}
          onClick={() => showLightBox(row.images[0])}
          alt="Not found Image"
          width={"40px"}
        />
      </>
    );
  }

  function ImgCoverFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row.cover}
          // onClick={() => showLightBox(row.cover)}
          alt="cover img"
          width={"50px"}
        />
      </>
    );
  }

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  function ManufacturerFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 align-items-start">
        <Link to={`/manufacturers-details/${row?.manufacturerDetail?._id}`}>
          <div style={{ width: '40px' }}><img src={row?.manufacturerDetail?.logo} width="40px" /></div>
        </Link>
        <div className="flex-product text-start">
          <Link to={`/manufacturers-details/${row?.manufacturerDetail?._id}`} className="mb-0">{row?.manufacturerDetail?.companyName}</Link>
          {/* <p className="mb-0">{row?.manufacturerDetail?.mobile}, </p> */}
          <p className="mb-0">{row?.manufacturerDetail?.address}</p>
        </div>
      </div>
    );
  }
  function KukliesCommFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 justify-content-center text-center align-items-center">
        <h5 className="mb-0">{row?.adminCommission?.toLocaleString()}%</h5>
        <button type="button" onClick={() => CMtoggleModel(row)} className="btn btn-primary" style={{ padding: '2px 7px' }}>
          <i className="fal fa-edit" />
        </button>
      </div>
    );
  }

  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "downloaded-image.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  const components = [
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Product Name</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.name}
          onChange={(e) => updateFilter("name", e.target.value)}
          name="name"
          className="form-control"
        />
      </div>
    </div>,
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Product Description</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.description}
          onChange={(e) => updateFilter("description", e.target.value)}
          name="description"
          className="form-control"
        />
      </div>
    </div>,

    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">unit</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.unit}
          onChange={(e) => updateFilter("unit", e.target.value)}
          name="unit"
          className="form-control"
        />
      </div>
    </div>,
    <div className="row mb-4" key="title">
      <label className="col-sm-3 col-form-label">Product CreatedAt</label>
      <div className="col-sm-6">
        <input
          type="text"
          value={filter.createdAt}
          onChange={(e) => updateFilter("createdAt", e.target.value)}
          name="createdAt"
          className="form-control"
        />
      </div>
    </div>,

    <div className="mt-5 mt-lg-4" key="submit">
      <div className="row justify-content-end">
        <div className="col-sm-9">
          <div>
            <button
              type="button"
              onClick={applyFilter}
              className="btn btn-primary w-md"
            >
              Filter
            </button>
            <button
              onClick={resetFilter}
              type="button"
              className="btn btn-danger w-md mx-4"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>,
  ];

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },

    {
      dataField: "images[]",
      text: "Product image",
      sort: false,
      formatter: ProductFormatter,
    },

    {
      dataField: "name",
      text: "Product Name",
      sort: false,
    },
    {
      text: "Manufacturer Info",
      sort: false,
      formatter: ManufacturerFormatter,
    },
    {
      dataField: "unit",
      text: "Unit",
      sort: false,
    },
    {
      text: "kulies Commission",
      sort: false,
      formatter: KukliesCommFormatter,
    },

    {
      text: (
        <div className="w-34"> Status
          <i
            data-tip
            data-for="title-tooltip"
            className="fa fa-info-circle"
            style={{ marginLeft: '5px', cursor: 'pointer' }}
          ></i>

          <ReactTooltip id="title-tooltip" place="bottom">
            If active, the product will be visible to users. If inactive, users won’t be able to see the product.
          </ReactTooltip>
        </div>
      ),
      sort: false,
      formatter: activeFormatter,
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: iconFormatter,
      sort: false,
    },
  ];
  const handleChange = (event) => {
    setSizePerPage(event.target.value);
    if (currentPage != 1) {
      setCurrentPage(1);
    } else {
      ProductManagment(null, event.target.value);
    }
  };
  const handlesorting = (event) => {
    setsort(event.target.value);
  };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handlesSearch = (event) => {
    setSearchText(event.target.value);
  };
  const handleReload = () => {
    setSearchText("");
    ProductManagmentlist();
  };

  function iconFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        {/* <button type="button" class="btn btn-info" onClick={() => toggleModel(row)}>
          <i className="fal fa-shopping-cart"></i>&nbsp;
          Buy Product</button> */}
        <button type="button" className=" btn btn-primary text-light">

          <Link
            to={{
              pathname: `/product-details/${row?._id}`,
              state: { row },
            }}
          >
            <i className="fal fa-eye text-light"></i>
          </Link>
        </button>



        {/* <button type="button" className=" btn btn-primary">
          <Link
            to={{
              pathname: `/updateProduct`,
              state: { row },
            }}
          >
            <i className="fal fa-edit fs-5 text-light"></i>
          </Link>
        </button>

        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handlerdelete(row._id)}
        >
          <i className="fal fa-trash  fs-5"></i>
        </button> */}
      </div>
    );
  }

  const limit = 10;

  const handleUpdateKuliesComm = async (_id) => {
    // setLoader(true);
    if (kuliesCommValue <= 0) {
      toast.warn('Kulies Commission value must be a positive number and at least 1.');
      return false;
    }
    try {
      const response = await postRequest(`setting/admin-update-product-commission`, {
        productId: _id,
        adminCommission: kuliesCommValue
      });
      if (response?.status) {
        Swal.fire({
          title: 'Success!',
          text: 'Kulies Commission has been successfully updated.',
          icon: 'success',
          confirmButtonText: 'Okay'
        });
        setCMshow(false);
        ProductManagment();
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const ProductManagment = async (filterArgs = [], limit = null) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: limit ? limit : sizePerPageOrg,
      page: currentPage,
      sortField: sort,
      sortOrder: sortOrder,
    };

    if (filterArgs?.length) {
      payload.filterArgs = filterArgs;
    } else {
      if (searchText) {
        payload.search = searchText;
      }
    }
    try {
      const response = await postRequest(`product/product-list-admin`, payload);
      const data = response.data;

      setTotalPage(data.total);
      setCurrentFPage(data.currentPage);

      console.log("table data", data.ProductData);
      setProductdata(data?.list);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const ProductManagmentlist = async (filterArgs = [], limit = null) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: limit ? limit : sizePerPageOrg,
      page: currentPage,
      sortField: sort,
      sortOrder: sortOrder,
    };

    try {
      const response = await postRequest(`product/product-list-admin`, payload);
      const data = response.data;

      setTotalPage(data.total);
      setCurrentFPage(data.currentPage);

      console.log("table data", data.ProductData);
      setProductdata(data?.list);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const handlerdelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Product",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let body = { ProductId: id };
        postRequest("Product/remove", body).then((data) => {
          let Product = data.status;
          console.log(data, "Product");
          if (Product == 1) {
            Swal.fire("Deleted!", "Deleted successfully");
            ProductManagment();
          }
        });
      }
    });
  };

  const handleKuliesCommChange = (e) => {
    let value = e.target.value;
    if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
      setKuliesCommValue(value);
      setComValidation('')
    } else {
      setComValidation('Please enter a value between 0 and 100.');
    }
  };

  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          <div className="col-md-6">
            <div className="page-title-box">
              <h4>Product Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Product Management</li>:{" "}
                <li className="breadcrumb-item">Product List</li>
              </ol>
            </div>
          </div>
          <div className="col-md-6 text-end">
            {/* {canExport && (
              <button
                onClick={() => {
                  exportCSV();
                }}
                type="button"
                className="btn btn-primary mx-2"
              >
                <i class="fas fa-upload"></i> Export CSV
              </button>
            )} */}


          </div>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={Productdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>

                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>

                                    <option value="20">20</option>

                                    <option value="50">50</option>
                                  </select>

                                  <label className="mb-0 text-label ms-3">
                                    Sort By:
                                  </label>
                                  <select
                                    value={sort}
                                    onChange={handlesorting}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="name">Product Name</option>

                                    <option value="description">
                                      Description{" "}
                                    </option>
                                    <option value="unit">Unit </option>
                                  </select>
                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>
                                  </select>
                                  <div className="filter-item">
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        handlesSearch(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        ProductManagment();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>

                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>
                                    <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button>
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
        {/* {openLightbox && (
          <>
            <Lightbox
              mainSrc={image}
              onCloseRequest={() => setOpenLightBox(false)}
              toolbarButtons={[
                <button
                  className="btn btn-primary"
                  key="download"
                  onClick={handleDownload}
                >
                  Download
                </button>,
              ]}
            />
          </>
        )} */}
      </React.Fragment>
      <Modal
        isOpen={CMshow}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered={true}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            kulies Commission
          </h5>
          <button
            onClick={() => setCMshow(false)}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="product-item">
            <div className="image-product">
              <img src={kuliesComm?.images?.[0]} alt={kuliesComm?.images?.[0]} />
            </div>
            <div className="product-info" style={{ width: '50%' }}>
              <h5>{kuliesComm?.name}</h5>
              <div className="manufacturedetail">
                <div className="logo-manufacturedetail"> <img src={kuliesComm?.manufacturerDetail?.logo} /></div>
                {kuliesComm?.manufacturerDetail?.companyName} <br />
                {kuliesComm?.manufacturerDetail?.address}
              </div>
              <label className="mb-0">kulies Commission</label>
              <div className="cart_qty mb-2 mt-0">
                <div className="input-group quantity-prod">
                  <input
                    className="form-control input-number qty-input"
                    type="number"
                     min="0"
                     max="100"
                    onChange={(e) => handleKuliesCommChange(e)}
                    value={kuliesCommValue}
                  />
                </div>
              </div>
              <p className="mb-0 text-danger">{comValidation}</p>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-danger" onClick={() => setCMshow(false)}>
            Cancel
          </button>
          <button type="button" className="btn btn-info" onClick={() => handleUpdateKuliesComm(kuliesComm?._id)}>
            Save
          </button>
        </div>

      </Modal>

      <BuyProduct
        show={model}
        data={buyProductdata}
        closeModal={closeModal}
        components={components}
      />
      {/* <FilterModal
        show={model}
        closeModal={closeModal}
        components={components}
      /> */}
    </>
  );
};

export default ProductManagementlist;
